export default () => ({
  isCartOpen: false,
  isCartActive: false,
  cartLength: 0,
  toggleCart: function () {
    if (!this.isCartActive) {
      // delay for smooth animation
      this.isCartOpen = !this.isCartOpen;
      setTimeout(() => {
        this.isCartActive = this.isCartOpen;
      });
    } else {
      this.isCartActive = false;
      setTimeout(() => {
        this.isCartOpen = false;
      }, 500);
    }
  },
});
